<template>
  <div class="recent-donations flex flex-grow flex-col align-center">
    <div class="text-sm weight-600 title mb-3 text-center">RECENT DONATIONS</div>
    <div
      v-if="companyAdminStore.recentDonations.length === 0"
      class="no-donations text-center"
      data-test="no-donations"
    >
      <p class="text-xl font-semibold mt-2 mb-3 mx-3">You haven’t made any donations yet.</p>
      <p class="text-base">Find the causes that matter most to you on our organization search page!</p>

      <div class="flex flex-col pt-4 pb-6 self-center items-center w-full">
        <Button
          label="Browse Organizations"
          variant="outlined"
          :raised="isHovered"
          @click="redirectToCMS"
          @mouseover="isHovered = true"
          @mouseleave="isHovered = false"
          data-test="browse-organizations-button"
        />
      </div>
    </div>
    <div v-else>
      <div
        v-for="(donation, index) in companyAdminStore.recentDonations"
        :key="`donation_${index}`"
        class="recent-donation-tile bg-white rounded-lg my-2 shadow-md"
        data-test="recent-donation"
      >
        <div class="donations-top p-3 flex flex-grow flex-col">
          <div class="flex flex-grow justify-between">
            <div class="donation-date text-xs font-light">
              {{ filters.formatDate(donation.enteredDate, 'long') }}
            </div>
          </div>
          <div class="donation-amount text-lg font-semibold">
            {{ filters.formatMoney(donation.amount) }}
          </div>
          <div class="donation-cause text-sm font-normal me-4">
            {{ donation.organization.organizationName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import filters from '@/helpers/filters';
import { ref } from 'vue';
const donorStore = useDonorStore();
const companyAdminStore = useCompanyAdminStore();

const redirectToCMS = () => {
  window.location.href = donorStore.domain.replace(/\/$/, '') + '/organizations';
};

const isHovered = ref(false);
</script>
